import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "audience-historic-table" };
const _hoisted_2 = ["id", "data-message", "title"];
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = { key: 2 };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-clock" }, null, -1);
const _hoisted_6 = { key: 3 };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-calendar-14px" }, null, -1);
const _hoisted_8 = { key: 0 };
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1);
import { computed } from 'vue';
import { useStore } from 'vuex';
import { humanizeDate } from '@/utilities/formatters';
import { getConnectorIcon } from '@/features/AudienceManager/utils';
import ListPagination from '@/components/_atoms/ListPagination.vue';
import InfoCard from '@/components/_atoms/InfoCard.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceHistoricTable',
    setup(__props) {
        const store = useStore();
        const columns = [
            { key: 'status', label: 'audiences.status.title' },
            { key: 'connector', label: 'integrations.connector' },
            { key: 'audience', label: 'audiences.single-title' },
            { key: 'duration', label: 'audiences.duration' },
            { key: 'exportDate', label: 'audiences.exportation-date' },
            { key: 'total', label: 'audiences.base-size' },
        ];
        const isLoadingHistoricStage = computed(() => store.getters['audienceManager/isLoadingHistoricStage']);
        const historicLogs = computed(() => store.getters['audienceManager/historicLogs']);
        const getPagination = computed(() => store.getters['audienceManager/getPagination']);
        const updateDataTable = (_, pagination) => {
            store.dispatch('audienceManager/fetchHistoric', pagination);
        };
        const getWidth = (column) => {
            const width = {
                status: 120,
                connector: 120,
                audience: 200,
                duration: 120,
                exportDate: 150,
                total: 150,
            };
            const hasWidth = Object.keys(width).includes(column);
            return hasWidth ? width[column] : 140;
        };
        return (_ctx, _cache) => {
            const _component_el_popover = _resolveComponent("el-popover");
            const _component_el_table_column = _resolveComponent("el-table-column");
            const _component_el_table = _resolveComponent("el-table");
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_el_table, {
                        data: historicLogs.value,
                        style: { "width": "100%" }
                    }, {
                        empty: _withCtx(() => [
                            _createVNode(InfoCard)
                        ]),
                        default: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (column, index) => {
                                return _createVNode(_component_el_table_column, {
                                    key: index,
                                    prop: column.key,
                                    label: _ctx.$t(column.label),
                                    "min-width": getWidth(column.key)
                                }, {
                                    default: _withCtx((scope) => [
                                        (column.key === 'status')
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                id: `historic-status-${index}`,
                                                class: _normalizeClass(["audience-historic-table__status", `audience-historic-table__status--${scope.row.status}`]),
                                                "data-message": scope.row.message,
                                                "data-toggle": "tooltip",
                                                "data-placement": "top",
                                                title: scope.row.message
                                            }, _toDisplayString(_ctx.$t(`audiences.status.${scope.row.status}`)), 11, _hoisted_2))
                                            : _createCommentVNode("", true),
                                        (column.key === 'connector')
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                (scope.row.connector)
                                                    ? (_openBlock(), _createElementBlock("img", {
                                                        key: 0,
                                                        src: _unref(getConnectorIcon)(scope.row.connector),
                                                        alt: scope.row.connector
                                                    }, null, 8, _hoisted_3))
                                                    : _createCommentVNode("", true)
                                            ], 64))
                                            : _createCommentVNode("", true),
                                        (column.key === 'duration')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                _hoisted_5,
                                                _createTextVNode(" " + _toDisplayString(scope.row.duration), 1)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (column.key === 'exportDate')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                _hoisted_7,
                                                _createTextVNode(" " + _toDisplayString(_unref(humanizeDate)(scope.row.exportDate)), 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    header: _withCtx(() => [
                                        (column.key === 'audience')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                                _createTextVNode(_toDisplayString(_ctx.$t(columns[2].label)) + " ", 1),
                                                _createVNode(_component_el_popover, {
                                                    trigger: "hover",
                                                    placement: "top",
                                                    width: 210
                                                }, {
                                                    reference: _withCtx(() => [
                                                        _hoisted_10
                                                    ]),
                                                    default: _withCtx(() => [
                                                        _createElementVNode("p", {
                                                            innerHTML: _ctx.$t('audiences.audience-name-tooltip')
                                                        }, null, 8, _hoisted_9)
                                                    ]),
                                                    _: 1
                                                })
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                }, 1032, ["prop", "label", "min-width"]);
                            }), 64))
                        ]),
                        _: 1
                    }, 8, ["data"])
                ]),
                (!isLoadingHistoricStage.value || getPagination.value.count)
                    ? (_openBlock(), _createBlock(ListPagination, {
                        key: 0,
                        data: getPagination.value,
                        "limit-range": [5, 10, 20, 30, 50],
                        "show-list-pages": false,
                        "show-quantity-lines": true,
                        identify: "audience-historic-table",
                        onChangePage: updateDataTable
                    }, null, 8, ["data"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
